import "./styles.less";
import { useEffect, useState } from "react";
import { getTurboEndTime, formatRemaining, TurboProduct } from "./hook";

// INF-106 — chip «↑ EN EL TOP» + countdown del Asciende en el listado (señales v2, solo fincaraiz).
// El tick por segundo vive acá (hoja, sin dynamic imports): solo re-renderiza este chip,
// nunca la ListingCard entera. A cero se oculta (render null).
export const AsciendeChip = ({ turbo }: { turbo?: TurboProduct }) => {
	const [label, setLabel] = useState<string>("");

	useEffect(() => {
		const end = getTurboEndTime(turbo);
		if (!end) {
			setLabel("");
			return;
		}
		let intervalId: any = null;
		const tick = () => {
			const remaining = end - Date.now();
			if (remaining <= 0) {
				setLabel("");
				if (intervalId) clearInterval(intervalId);
				return;
			}
			setLabel(formatRemaining(remaining));
		};
		tick();
		intervalId = setInterval(tick, 1000);
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [turbo && turbo.end_date, turbo && turbo.start_hour]);

	if (!label) return null;

	return (
		<span className="asciende-chip">
			<svg
				className="asciende-chip__arrow"
				viewBox="0 0 16 19.4783"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M3.33333 9.73913L8 4.05797L12.6667 9.73913"
					stroke="#243E88"
					strokeWidth={2}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 15.4203V4.05797"
					stroke="#243E88"
					strokeWidth={2}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
			<span className="asciende-chip__label">En el top</span>
			<span className="asciende-chip__clock">{label}</span>
		</span>
	);
};
